import { useEffect, useState } from "react";
import { Navbar, Nav, Container, NavDropdown } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { LinkContainer } from "react-router-bootstrap";
import { Link } from "react-router-dom";
import { useNavigate, useLocation } from "react-router-dom";
import {
  FaUser,
  FaUsers,
  FaClipboardList,
  FaChartLine,
  FaWhatsappSquare,
  FaPhoneAlt,
} from "react-icons/fa"; // Add the icons you need
import { IoFastFoodSharp } from "react-icons/io5";
import { FaClock } from "react-icons/fa6";
import {
  RiQrCodeFill,
  RiBuilding4Fill,
  RiLogoutCircleRLine,
  RiFileListLine,
  RiBodyScanFill,
  RiPassPendingFill,
  RiHome8Line,
} from "react-icons/ri";

import { CgGym, CgMenuBoxed } from "react-icons/cg";
import {
  MdAccountBalance,
  MdQrCode2,
  MdManageAccounts,
  MdCalendarToday,
} from "react-icons/md";

import preferredLanguage from "../assets/preferredLanguage.json";
import { getDateOfLast } from "../utils/getCurrentDate";
import GymSwitcher from "./GymSwitcher";
import {
  useAssociateLogoutMutation,
  useLazyGetMyDetailsQuery,
} from "../slices/associatesSlice";
import { performMultiGymLogout } from "../utils/performMultiGymLogout";

const HeaderTop = function () {
  const { userInfo } = useSelector((state) => state.auth);
  const selectedLanguage = userInfo?.preferredLanguage
    ? userInfo?.preferredLanguage
    : "English";
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  // The toggle menu is controlled so it can be closed from outside itself.
  // The bottom menu and the direct-menu icons are not children of this Navbar,
  // so react-bootstrap's collapseOnSelect never sees those clicks and the menu
  // used to stay open over the newly opened page.
  const [menuExpanded, setMenuExpanded] = useState(false);

  useEffect(() => {
    setMenuExpanded(false);
  }, [pathname]);

  useEffect(() => {
    if (!menuExpanded) return;
    const closeOnOutsideTap = (e) => {
      // Ignore taps on the menu panel itself and on the toggle (which owns its
      // own open/close), plus any modal opened from inside the menu.
      if (
        !e.target?.closest?.(
          "#basic-navbar-nav, .navbar-toggler, .modal, .offcanvas"
        )
      ) {
        setMenuExpanded(false);
      }
    };
    document.addEventListener("pointerdown", closeOnOutsideTap);
    return () => document.removeEventListener("pointerdown", closeOnOutsideTap);
  }, [menuExpanded]);

  const [logoutApi] = useAssociateLogoutMutation();
  const [triggerMyDetails] = useLazyGetMyDetailsQuery();
  let gymId;
  if (userInfo) {
    gymId = userInfo?.gymId?._id;
  }
  // Shared with the desktop header so both drop only the ACTIVE gym and fall
  // back to a parked one; this used to always full-logout on mobile.
  const handleLogout = async () => {
    await performMultiGymLogout({
      userInfo,
      dispatch,
      navigate,
      logoutApi,
      triggerMyDetails,
    });
  };

  const bgColor = userInfo?.gymId?.themeColors?.headerBg || "rgb(10, 90, 106)";
  const headerTextColor = userInfo?.gymId?.themeColors?.headerText || "#FFFFFF";

  // Only the toggler button reads these Bootstrap variables in this build.
  const navThemeVars = {
    "--bs-navbar-toggler-border-color": "rgba(255, 255, 255, 0.35)",
    "--bs-navbar-toggler-icon-bg": `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 0.9%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e")`,
  };
  return (
    <header
      className="top-menu"
      // className={`${userInfo ? userInfo.themeColor : "cyan"}ThemeHeaderTop`}
      style={{
        position: "sticky",
        top: "0px",
        zIndex: 6,
        padding: "2rem 0rem 0.5rem 0rem",

        backgroundColor: bgColor,
      }}
    >
      <Navbar
        expand="md"
        collapseOnSelect
        expanded={menuExpanded}
        onToggle={setMenuExpanded}
        style={{
          ...navThemeVars,
          height: "50px",
          backgroundColor: "inherit",
          color: headerTextColor,
        }}
      >
        <Container
          style={{
            backgroundColor: "inherit",
            color: "inherit",
          }}
        >
          {!userInfo && <h6>zpotter Technologies</h6>}

          {userInfo ? (
            <div
              style={{
                width: "80%",
                // backgroundColor: "#000",
                display: "flex",
                justifyContent: "space-around",
                zIndex: 1000,
                color: "inherit",
              }}
            >
              <Link
                to="/dashboard"
                style={{ ...menuButtonStyle, textDecoration: "none" }}
              >
                <RiHome8Line
                  style={{
                    width: "1.5rem",
                    height: "1.5rem",
                    marginBottom: "0.3rem",
                  }}
                />
                Dashboard
              </Link>

              <Link
                to="/markAttendance"
                style={{ ...menuButtonStyle, textDecoration: "none" }}
              >
                <FaClock
                  style={{
                    width: "1.5rem",
                    height: "1.5rem",
                    marginBottom: "0.3rem",
                  }}
                />
                {preferredLanguage[selectedLanguage]?.directMenu.inOut}
              </Link>

              {(userInfo.role === "owner" ||
                userInfo.role === "Super Admin") && (
                <Link
                  to="/trends"
                  style={{ ...menuButtonStyle, textDecoration: "none" }}
                >
                  <MdCalendarToday
                    style={{
                      width: "1.5rem",
                      height: "1.5rem",
                      marginBottom: "0.3rem",
                    }}
                  />
                  {preferredLanguage[selectedLanguage]?.directMenu.today}
                </Link>
              )}

              {(userInfo.role === "owner" ||
                userInfo.role === "Super Admin") && (
                <>
                  <Link
                    to="/subscriptions"
                    style={{ ...menuButtonStyle, textDecoration: "none" }}
                  >
                    <RiFileListLine
                      style={{
                        width: "1.5rem",
                        height: "1.5rem",
                        marginBottom: "0.3rem",
                      }}
                    />
                    {preferredLanguage[selectedLanguage]?.subscriptions}
                  </Link>
                  <Link
                    to="/accounts"
                    style={{ ...menuButtonStyle, textDecoration: "none" }}
                  >
                    <MdAccountBalance
                      style={{
                        width: "1.5rem",
                        height: "1.5rem",
                        marginBottom: "0.3rem",
                      }}
                    />
                    {preferredLanguage[selectedLanguage]?.directMenu.accounts}
                  </Link>
                </>
              )}
            </div>
          ) : (
            <></>
          )}

          <Navbar.Toggle
            aria-controls="basic-navbar-nav"
            style={{
              marginRight: "1%",
              backgroundColor: "rgba(255, 255, 255, 0.14)",
              borderColor: "rgba(255, 255, 255, 0.35)",
              borderRadius: "0.5rem",
              padding: "0.35rem 0.6rem",
            }}
          />
          <Navbar.Collapse
            id="basic-navbar-nav"
            style={{
              marginRight: "1%",
              // .nav-link reads var(--bs-gray) in this build, so scoping it
              // here recolours the menu labels and their carets. The dropdown
              // panels are unaffected: --bs-body-color resolves at :root.
              "--bs-gray": headerTextColor,
              backgroundColor: bgColor,
              // A translucent wash instead of a fixed shade, so the panel reads
              // as slightly raised whatever headerBg the gym has themed.
              backgroundImage:
                "linear-gradient(rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.05))",
              color: headerTextColor,
              borderTop: "1px solid rgba(255, 255, 255, 0.18)",
              borderRadius: "0 0 0.75rem 0.75rem",
              padding: "0.4rem 0.75rem 0.7rem",
              boxShadow: "0 0.75rem 1.5rem rgba(0, 0, 0, 0.3)",
            }}
          >
            <Nav className="ms-auto" style={{ backgroundColor: "transparent" }}>
              {userInfo ? (
                <>
                  {/* <LinkContainer to="/markAttendance">
                    <Nav.Link>
                      {" "}
                      {preferredLanguage[selectedLanguage]?.attendance}
                    </Nav.Link>
                  </LinkContainer> */}

                  {/* {userInfo.role === "owner" ||
                  userInfo.role === "Super Admin" ? (
                    <LinkContainer to="/trends">
                      <Nav.Link>
                        {" "}
                        <FaUserPlus style={{ marginRight: "2px" }} />
                        {
                          preferredLanguage[selectedLanguage]?.attendancePage
                            .todaysTrend
                        }
                      </Nav.Link>
                    </LinkContainer>
                  ) : (
                    <></>
                  )} */}
                  {/* <LinkContainer to="/userRegistration">
                    <Nav.Link>
                      {" "}
                      {preferredLanguage[selectedLanguage]?.userReg}
                    </Nav.Link>
                  </LinkContainer> */}
                  {/* <LinkContainer to="/visitors">
                    <Nav.Link>
                      {" "}
                      {preferredLanguage[selectedLanguage]?.visitors}
                    </Nav.Link>
                  </LinkContainer> */}
                  {/* <LinkContainer to="/attendanceList">
                    <Nav.Link>
                      {" "}
                      {preferredLanguage[selectedLanguage]?.attendanceList}
                    </Nav.Link>
                  </LinkContainer> */}

                  <NavDropdown
                    title={
                      preferredLanguage[selectedLanguage]?.memberManagement
                    }
                  >
                    {/* <LinkContainer to="/allUsers">
                      <NavDropdown.Item>
                        <FaUsers style={{ marginRight: "2px" }} />
                        {preferredLanguage[selectedLanguage]?.allMembers}
                      </NavDropdown.Item>
                    </LinkContainer> */}
                    <LinkContainer to="/users">
                      <NavDropdown.Item>
                        <FaUsers style={{ marginRight: "2px" }} />
                        {preferredLanguage[selectedLanguage]?.activeMember}
                      </NavDropdown.Item>
                    </LinkContainer>

                    <LinkContainer to="/regPendingUsers">
                      <NavDropdown.Item>
                        <RiPassPendingFill style={{ marginRight: "2px" }} />
                        Pending Subscriptions
                      </NavDropdown.Item>
                    </LinkContainer>

                    <LinkContainer to="/ptUsers">
                      <NavDropdown.Item>
                        <RiBodyScanFill style={{ marginRight: "2px" }} />
                        PT Members
                      </NavDropdown.Item>
                    </LinkContainer>

                    {(userInfo.role === "owner" ||
                      userInfo.role === "Super Admin") && (
                      <LinkContainer to="/userSmartAnalytics">
                        <NavDropdown.Item>
                          <FaChartLine style={{ marginRight: "2px" }} />
                          Smart Analytics
                        </NavDropdown.Item>
                      </LinkContainer>
                    )}
                    {/* <LinkContainer to="/subsExpiredUsers">
                      <NavDropdown.Item>
                        <FaUsersSlash style={{ marginRight: "2px" }} />
                        {preferredLanguage[selectedLanguage]?.inActiveMembers}
                      </NavDropdown.Item>
                    </LinkContainer> */}
                    {/* {userInfo.role === "owner" ||
                    userInfo.role === "Super Admin" ? (
                      <LinkContainer to="/payments">
                        <NavDropdown.Item>
                          <FaMoneyBillAlt style={{ marginRight: "2px" }} />
                          {preferredLanguage[selectedLanguage]?.paymentsList}
                        </NavDropdown.Item>
                      </LinkContainer>
                    ) : (
                      <></>
                    )} */}
                    {/* <LinkContainer to="/regPendingUsers">
                      <NavDropdown.Item>
                        <RiPassPendingFill style={{ marginRight: "2px" }} />
                        {preferredLanguage[selectedLanguage]?.pendingReg}
                      </NavDropdown.Item>
                    </LinkContainer> */}
                    {userInfo.role === "owner" ||
                    userInfo.role === "Super Admin" ||
                    userInfo.role === "Admin" ? (
                      <>
                        <LinkContainer to="/whatsAppMessages">
                          <NavDropdown.Item>
                            {" "}
                            <FaWhatsappSquare style={{ marginRight: "2px" }} />
                            {
                              preferredLanguage[selectedLanguage]
                                ?.wsNotification
                            }
                          </NavDropdown.Item>
                        </LinkContainer>
                        <LinkContainer to="/wsChat">
                          <NavDropdown.Item>
                            {" "}
                            <FaWhatsappSquare style={{ marginRight: "2px" }} />
                            WhatsApp Chat
                          </NavDropdown.Item>
                        </LinkContainer>
                      </>
                    ) : (
                      ""
                    )}
                    <LinkContainer to="/workoutPlan">
                      <NavDropdown.Item
                        disabled={
                          userInfo?.gymId?.subscriptionType !== "Premium" &&
                          userInfo?.gymId?.subscriptionType !== "Free"
                        }
                      >
                        <IoFastFoodSharp style={{ marginRight: "2px" }} />
                        Workout Plan
                      </NavDropdown.Item>
                    </LinkContainer>
                    <LinkContainer to="/dietPlan">
                      <NavDropdown.Item
                        disabled={
                          userInfo?.gymId?.subscriptionType !== "Premium" &&
                          userInfo?.gymId?.subscriptionType !== "Free"
                        }
                      >
                        <IoFastFoodSharp style={{ marginRight: "2px" }} />
                        Diet Plan
                      </NavDropdown.Item>
                    </LinkContainer>
                    <LinkContainer to="/showToVisitors">
                      <NavDropdown.Item
                        disabled={
                          userInfo?.gymId?.subscriptionType !== "Premium" &&
                          userInfo?.gymId?.subscriptionType !== "Free"
                        }
                      >
                        <IoFastFoodSharp style={{ marginRight: "2px" }} />
                        Member Communication
                      </NavDropdown.Item>
                    </LinkContainer>
                    <LinkContainer to="/memberAppQrCode">
                      <NavDropdown.Item>
                        <IoFastFoodSharp style={{ marginRight: "2px" }} />
                        App for Members
                      </NavDropdown.Item>
                    </LinkContainer>
                    {/* {userInfo.role === "owner" ||
                    userInfo.role === "Super Admin" ? (
                      <LinkContainer to="/promotionalMessage">
                        <NavDropdown.Item>
                          {" "}
                          <FaWhatsapp style={{ marginRight: "2px" }} />
                          {preferredLanguage[selectedLanguage]?.sendAds}
                        </NavDropdown.Item>
                      </LinkContainer>
                    ) : (
                      ""
                    )} */}
                  </NavDropdown>
                  <NavDropdown
                    title={preferredLanguage[selectedLanguage]?.gymManagement}
                  >
                    <LinkContainer to="/packages">
                      <NavDropdown.Item>
                        <CgMenuBoxed style={{ marginRight: "2px" }} />
                        Packages
                      </NavDropdown.Item>
                    </LinkContainer>
                    {userInfo.role === "owner" ||
                    userInfo.role === "Super Admin" ||
                    userInfo.role === "Admin" ? (
                      <LinkContainer to="/equipments">
                        <NavDropdown.Item>
                          {" "}
                          <CgGym style={{ marginRight: "2px" }} />
                          {
                            preferredLanguage[selectedLanguage]
                              ?.equipmentManagement
                          }
                        </NavDropdown.Item>
                      </LinkContainer>
                    ) : (
                      <></>
                    )}
                    {userInfo.role === "owner" ||
                    userInfo.role === "Super Admin" ? (
                      <LinkContainer to="/supplementSales">
                        <NavDropdown.Item>
                          {" "}
                          <CgGym style={{ marginRight: "2px" }} />
                          Supplement Sales
                        </NavDropdown.Item>
                      </LinkContainer>
                    ) : (
                      <></>
                    )}
                    {/* {userInfo.role === "owner" ||
                    userInfo.role === "Super Admin" ? (
                      <LinkContainer to="/accounts">
                        <NavDropdown.Item>
                          {" "}
                          <MdAccountBalance style={{ marginRight: "2px" }} />
                          {preferredLanguage[selectedLanguage]?.accounts}
                        </NavDropdown.Item>
                      </LinkContainer>
                    ) : (
                      <></>
                    )} */}

                    <LinkContainer to="/events">
                      <NavDropdown.Item>
                        {" "}
                        <MdManageAccounts style={{ marginRight: "2px" }} />
                        Gym Events
                      </NavDropdown.Item>
                    </LinkContainer>
                    <LinkContainer to="/feedback">
                      <NavDropdown.Item>
                        {" "}
                        <MdManageAccounts style={{ marginRight: "2px" }} />
                        FeedBack
                      </NavDropdown.Item>
                    </LinkContainer>

                    <LinkContainer to="/associatesAttendance">
                      <NavDropdown.Item>
                        {" "}
                        <MdManageAccounts style={{ marginRight: "2px" }} />
                        {
                          preferredLanguage[selectedLanguage]
                            ?.associateAttendanceList
                        }
                      </NavDropdown.Item>
                    </LinkContainer>

                    <LinkContainer to="/associates">
                      <NavDropdown.Item>
                        {" "}
                        <MdManageAccounts style={{ marginRight: "2px" }} />
                        {preferredLanguage[selectedLanguage]?.adminManagement}
                      </NavDropdown.Item>
                    </LinkContainer>

                    <LinkContainer to="/dashboard">
                      <NavDropdown.Item>
                        <RiHome8Line style={{ marginRight: "2px" }} />
                        Dashboard
                      </NavDropdown.Item>
                    </LinkContainer>
                    <LinkContainer to="/gymProfile">
                      <NavDropdown.Item>
                        {" "}
                        <RiBuilding4Fill style={{ marginRight: "3px" }} />
                        {preferredLanguage[selectedLanguage]?.gymProfile}
                      </NavDropdown.Item>
                    </LinkContainer>
                  </NavDropdown>

                  {/* Same switcher the desktop header uses, surfaced here as its
                      own menu entry since Bootstrap has no nested dropdowns.
                      Hidden when there is nothing to switch to or add. */}
                  {(userInfo?.myGyms?.length > 0 ||
                    userInfo.role === "owner" ||
                    userInfo.role === "Super Admin") && (
                    <GymSwitcher
                      id="gym-switcher-dropdown-mobile"
                      title="Switch Gym"
                    />
                  )}

                  <NavDropdown title={userInfo.firstName}>
                    <LinkContainer to="/profile">
                      <NavDropdown.Item>
                        <FaUser style={{ marginRight: "2px" }} />
                        My Profile
                      </NavDropdown.Item>
                    </LinkContainer>

                    <LinkContainer to="/qrCode">
                      <NavDropdown.Item>
                        <MdQrCode2 style={{ marginRight: "2px" }} />
                        {preferredLanguage[selectedLanguage]?.attendanceQrCode}
                      </NavDropdown.Item>
                    </LinkContainer>
                    <LinkContainer to="/qrcodeRegister">
                      <NavDropdown.Item>
                        <RiQrCodeFill style={{ marginRight: "2px" }} />
                        {preferredLanguage[selectedLanguage]?.regQrCode}
                      </NavDropdown.Item>
                    </LinkContainer>

                    <LinkContainer to="/contactUs">
                      <NavDropdown.Item>
                        {" "}
                        <FaPhoneAlt style={{ marginRight: "2px" }} />
                        {preferredLanguage[selectedLanguage]?.contactUs}
                      </NavDropdown.Item>
                    </LinkContainer>
                    <NavDropdown.Item onClick={handleLogout}>
                      <RiLogoutCircleRLine style={{ marginRight: "3px" }} />
                      {preferredLanguage[selectedLanguage]?.logout}
                    </NavDropdown.Item>
                  </NavDropdown>
                </>
              ) : (
                // <LinkContainer to="/">
                //   <Nav.Link>
                //     {preferredLanguage[selectedLanguage]?.login}
                //   </Nav.Link>
                // </LinkContainer>
                <></>
              )}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  );
};

const menuButtonStyle = {
  background: "none",
  border: "none",
  fontSize: "0.55rem",
  color: "inherit",
  cursor: "pointer",
  outline: "none",
  justifyContent: "center",
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  width: "100%",
};

export default HeaderTop;
